import {AxiosError} from 'axios';
import {useQuery, useQueryClient, UseQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {Article} from '../types';
import {useAccessToken} from '@eksab/hooks';

const queryKey = (slug: string, isLoggedIn: boolean) => ['news', slug, isLoggedIn];

const queryFn = (slug: string, isLoggedIn: boolean) =>
  api
    .get<{data: Article}>(`v3/news/${encodeURIComponent(slug)}${isLoggedIn ? '/auth' : ''}`)
    .then((res) => res.data.data);

export function useSingleNewsQuery(slug: string, options?: UseQueryOptions<Article, AxiosError>) {
  const isLoggedIn = !!useAccessToken()?.data;
  return useQuery<Article, AxiosError>(queryKey(slug, isLoggedIn), () => queryFn(slug, isLoggedIn), {
    ...options,
    enabled: !!slug,
    refetchOnWindowFocus: false,
  });
}

export function useInvalidateNewsQuery() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries(['news']);
}

useSingleNewsQuery.queryFn = queryFn;
useSingleNewsQuery.queryKey = queryKey;
